import Button from "@material-ui/core/Button";
import clsx from "clsx";
import React from "react";
import emoji from 'react-easy-emoji'
import TextareaAutosize from "react-textarea-autosize";

const MAX_LENGTH = 512;
const EMOJIS = [["thinking", "🤔"], ["sweating", "😰"], ["sh*t", "🤬"], ["clown", "🤡"], ["praying", "🙏"], ["coffin", "⚰️"]];

class ChatBox extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      value: "",
      too_quick: false,
    };

    this.textarea = React.createRef();
    this.can_send = true;
    this.send_timeout = null;
  }

  componentWillUnmount() {
    clearTimeout(this.send_timeout);
  }

  send() {
    const value = this.state.value.trim();
    if (!value) {
      return;
    }

    if (this.can_send) {
      this.props.sendMessage(value);
      this.setState({ value: "", too_quick: false, });
      this.can_send = false;
      this.send_timeout = setTimeout(() => this.can_send = true, 10000);
    } else {
      this.setState({ too_quick: true, });
    }
  }

  handleKeyDown = event => {
    // Enter sends only with a real keyboard + mouse; on touch keyboards Enter is a new line and the button sends.
    // isComposing: Enter that confirms an IME candidate must not send.
    if (event.key === "Enter" && !event.shiftKey && !event.nativeEvent.isComposing &&
        window.matchMedia("(pointer: fine)").matches) {
      event.preventDefault();
      this.send();
    }
  }

  appendEmoji(code) {
    this.setState(
      state => ({ value: (state.value + ":" + code + ":").slice(0, MAX_LENGTH), too_quick: false, }),
      () => {
        const textarea = this.textarea.current;
        textarea.focus();
        textarea.setSelectionRange(textarea.value.length, textarea.value.length);
      }
    );
  }

  render() {
    const symbol_overflow = this.state.value.trim().length >= MAX_LENGTH;
    const has_error = symbol_overflow || this.state.too_quick;

    return <div style={this.props.style} className={clsx("chatbox", this.props.className)}>
      <div className="chatbox-field">
        <TextareaAutosize
          ref={this.textarea}
          id={this.props.textarea_id}
          className={clsx("chatbox-input", has_error && "error", this.props.textarea_class)}
          placeholder="Начните писать здесь..."
          value={this.state.value}
          onChange={event => this.setState({ value: event.target.value, too_quick: false, })}
          onKeyDown={this.handleKeyDown}
          maxLength={MAX_LENGTH}
          minRows={2}
          maxRows={10}
        />
        <button
          type="button"
          className="chatbox-send"
          aria-label="Отправить"
          disabled={!this.state.value.trim()}
          onMouseDown={event => event.preventDefault() /* keep the keyboard open */}
          onClick={() => this.send()}
        >
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 16V4M10 4L4.5 9.5M10 4L15.5 9.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      </div>
      {has_error && <label className="chatbox-error-label" htmlFor={this.props.textarea_id}>{
        this.state.too_quick ? "Вы слишком часто пишете сообщения" : "Не более 512 символов"
      }</label>}
      <div className="chatbox-footer">
        <div className="chatbox-button-container">
          {EMOJIS.map(([code, symbol]) => <Button
            key={code}
            classes={ {root: "chatbox-emoji-button",} }
            onMouseDown={event => event.preventDefault() /* keep focus in the textarea */}
            onClick={() => this.appendEmoji(code)}
          >{emoji(symbol)}</Button>)}
        </div>
        <span className="chatbox-hint">Shift+Enter - новая строка<br />Enter - отправить</span>
      </div>
    </div>;
  }
}

export default ChatBox;
